<template>
  <v-container>
    <v-card id="embeDDed-card" elevation="0" class="py-4">

        <iframe
          class="frame-pdf"
          width="100%"
          height="100%"
          :src="portalData.menu"
        ></iframe>

    </v-card>
  </v-container>
</template>

<script>
import PhoneFrame from "./components/phone-overview.vue";
export default {
  components: {
    PhoneFrame,
  },
  data: () => {
    return {};
  },
  props: {
    portal: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    this.loadCustomerPortalData();
  },

  methods: {
    loadCustomerPortalData() {
      this.$store.dispatch("portal/loadCustomerPortalData", {
        parameters: {
          establishment_id: parseInt(this.$route.params.establishment_id, 10),
        },
      });
    },
  },

  computed: {
    hasMenu() {
      return this.portal !== null && this.portal.menu !== null;
    },
    portalData() {
      // console.log('data', this.$store.state.portal.portal.customerPortal);
      return this.$store.state.portal.portal.customerPortal;
    },
  },
};
</script>

<style lang="scss">
#embeDDed-card {
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: 100vh;
  width: 100%;
  display: inline-block;
  border-radius: 0px !important;
}
</style>